import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import hasProperty from "lodash/has";

function DateRange({
  id,
  name,
  onChange,
  onReturnKey,
  onClick = () => {},
  onBlur = () => {},
  errors,
  errorKey,
  classes = "",
  placeholder = "",
  fieldValues = [],
  formErrorClass = "form-error"
}) {
  const [formError, setFormError] = useState("");
  const [formErrorMessage, setFormErrorMessage] = useState("");

  useEffect(() => {
    setFormError("");
    setFormErrorMessage("");

    if (
      hasProperty(errors, "response.data.data.errors") &&
      errors.response.data.data.errors.length > 0
    ) {
      for (const iterator of errors.response.data.data.errors) {
        if (iterator.field === errorKey) {
          setFormError(formErrorClass || "form-error");
          setFormErrorMessage(iterator.message);
        }
      }
    }
  }, [name, errorKey, errors, formErrorClass]);

  const onInputChange = () => {
    setFormError("");
    setFormErrorMessage("");
  };

  return (
    <>
      <div className="form-text-vgroup">
        <label className="xs">
          From:
          <input
            type="date"
            id={id}
            name={name}
            placeholder={placeholder}
            value={fieldValues[0]}
            className={`mt-5 form-input ${classes} ${formError}`}
            onChange={e => {
              onInputChange(e);
              onChange({
                name: "from",
                value: e.target.value
              });
            }}
            onBlur={e => onBlur(e)}
            onClick={e => onClick(e)}
            onKeyUp={e =>
              e.which === 13 && onReturnKey ? onReturnKey() : null
            }
          />
        </label>
        <label className="xs">
          To:{" "}
          <input
            type="date"
            id={id}
            name={name}
            placeholder={placeholder}
            value={fieldValues[1]}
            className={`form-input ${classes} ${formError}`}
            onChange={e => {
              onInputChange(e);
              onChange({
                name: "to",
                value: e.target.value
              });
            }}
            onBlur={e => onBlur(e)}
            onClick={e => onClick(e)}
            onKeyUp={e =>
              e.which === 13 && onReturnKey ? onReturnKey() : null
            }
          />
        </label>
      </div>
      {formErrorMessage && <div className={formError}>{formErrorMessage}</div>}
    </>
  );
}

DateRange.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onReturnKey: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.object,
  errorKey: PropTypes.string.isRequired, // The string that the api error returns in the "field" key
  classes: PropTypes.string,
  placeholder: PropTypes.string,
  fieldValues: PropTypes.array,
  formErrorClass: PropTypes.string
};

export default DateRange;
